import React, { useState } from 'react'
import Modal from 'react-modal'
import SocialMediaQR from '../../images/social.jpg'
Modal.setAppElement('#root')

function ContactA4H() {
  const [Name, setName] = useState('')
  const [Email, setEmail] = useState('')
  const [Phone, setPhone] = useState('')
  const [Text, setText] = useState('')

  const [Interests, setInterests] = useState({
    volunteer: false,
    joinChapter: false,
    eventUpdates: false,
  })

  const [NameError, setNameError] = useState({})
  const [EmailError, setEmailError] = useState({})
  const [TextError, setTextError] = useState({})
  const [ModalIsOpen, setModalIsOpen] = useState(false)
  const [StateCity, setStateCity] = useState('')
  const [Organization, setOrganization] = useState('')
  const Validate = () => {
    const NameError = {}
    const EmailError = {}
    const TextError = {}
    let isValid = true

    if (Name.trim().length < 1) {
      NameError.errText = '*Name Field Required'
      isValid = false
    }

    if (Text.trim().length < 1) {
      TextError.errText = '*Message Field Required'
      isValid = false
    }

    if (Email.trim().length < 1) {
      EmailError.errText = '*Email Field Required'
      isValid = false
    } else if (!Email.includes('@') || !Email.includes('.')) {
      EmailError.errText = '*Invalid Email Field'
      isValid = false
    }

    setNameError(NameError)
    setEmailError(EmailError)
    setTextError(TextError)
    return isValid
  }


const doSubmit = async (e) => {
  e.preventDefault()

  if (Validate()) {

    // Open popup immediately
    setModalIsOpen(true)

    const payload = {
      data: [
        {
          Name: Name,
          Phone: Phone,
          Email: Email,
          StateCity: StateCity,
          Organization: Organization,
          Message: Text,
          Interests: Object.keys(Interests)
            .filter((key) => Interests[key])
            .join(", "),
        },
      ],
    }

    try {

      await fetch(
        "https://sheetdb.io/api/v1/tn8od94o0nhpc",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      )

      // Reset Form
      setName('')
      setPhone('')
      setEmail('')
      setStateCity('')
      setOrganization('')
      setText('')

      setInterests({
        volunteer: false,
        joinChapter: false,
        eventUpdates: false,
      })

    } catch (error) {
      console.log(error)
    }
  }
}





  const handleCheckbox = (e) => {
    const { name, checked } = e.target
    setInterests((prev) => ({ ...prev, [name]: checked }))
  }

  return (
    <>
        <style>{`
            .contact-checkboxes label {
            display: flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;
            font-size: 15px;
            margin-bottom: 12px;
            }

            .contact-checkboxes input {
            display: none;
            }

            .contact-checkboxes span.box {
            width: 18px;
            height: 18px;
            border: 2px solid #e63946;
            border-radius: 4px;
            position: relative;
            }

            .contact-checkboxes input:checked + span.box::after {
            content: "";
            position: absolute;
            width: 6px;
            height: 10px;
            border: solid #e63946;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            left: 4px;
            top: 1px;
            }
            .send-btn{
  background: linear-gradient(135deg, #6f3206ff, #6f3206ff);
  color: #fff !important;
  border: none;
  padding: 14px 14px;
  border-radius: 0px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.35s ease;
  box-shadow: 0 8px 20px rgba(255, 152, 0, 0.35);
}

.send-btn:hover{
  background: linear-gradient(135deg, #ff2a00ff, #e65100);
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 12px 28px rgba(255, 152, 0, 0.45);
}

.send-btn:active{
  transform: scale(0.98);
}
#form-inner input,
#form-inner textarea,
#form-inner select {
  font-size: 20px !important;
  color: #999;
}

#form-inner input::placeholder,
#form-inner textarea::placeholder {
  font-size: 20px;
  color: #999;
}

#form-inner select option {
  font-size: 18px;
  background: #111;
  color: #fff;
}
/* Hide placeholder when input/textarea is focused */
#form-inner input:focus::placeholder,
#form-inner textarea:focus::placeholder {
  color: transparent;
}

/* Optional: hide select text while focused */
#form-inner select:focus {
  color: transparent;
}

#form-inner select:focus option {
  color: #fff; /* keep dropdown options visible */
}     
/* ===== GOLD SHINE TEXT ===== */

.gold-shine{
  font-size: 30px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1.5;

  background: linear-gradient(
    90deg,
    #5c3b00 0%,
    #b8860b 20%,
    #ffd700 40%,
    #fff4b0 50%,
    #ffd700 60%,
    #b8860b 80%,
    #5c3b00 100%
  );

  background-size: 300% auto;

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  animation: goldShine 4s linear infinite;

  text-shadow:
    0 0 10px rgba(255,215,0,0.25),
    0 0 20px rgba(255,215,0,0.15);
}

@keyframes goldShine{
  0%{
    background-position: -200% center;
  }
  100%{
    background-position: 200% center;
  }
}       
        `}</style>
      <section id="contact" className="single-bg">
        <div className="bg-dark"></div>
        <div className="block">

          <div className="section-sub-title center">
            <article className="section-title-body white">
              <h1 className="head-title">
                Contact <span>Us</span>
              </h1>
            </article>
          </div>

          <div className="container">
            <div className="row">

              {/* Contact Details */}
              <div className="col-lg-6">
                <div className="white" style={{ textAlign: "left" }}>
                  <h4
                    className="widget-title"
                    style={{
                      fontWeight: "900",
                      fontSize: "22px",
                      color: "#173f73",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                    }}
                  ><i className="ion-email"></i> General Inquiries</h4>
                  <p style={{ paddingLeft: "38px" }}>
                    <strong>Americans4Hindus:</strong><br />
                    contact@americans4hindus.org
                  </p>
                  <p style={{ paddingLeft: "38px" }}>
                    <strong>Festival of Global:</strong><br />
                    contact@fiaonline.org
                  </p>

                  

                  

                  

                  <h4
                    className="widget-title"
                    style={{
                      fontWeight: "900",
                      fontSize: "22px",
                      color: "#173f73",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                    }}
                    ><i className="ion-home"></i> Office Address</h4>
                  <p style={{ paddingLeft: "38px" }}>
                    3155 Kearney Street, Fremont, CA 94538. United States
                  </p>
                  {/* Social Media QR Code */}
<div
  style={{
    marginTop: "30px",
    textAlign: "center",
    transform: "translateX(-90px)",
  }}
>
  <h4
    style={{
      fontWeight: "900",
      fontSize: "22px",
      color: "#173f73",
      letterSpacing: "2px",
      textTransform: "uppercase",
      marginBottom: "20px",
    }}
  >
    Follow us on Social Media
  </h4>

  <img
    src={SocialMediaQR}
    alt="Follow us on Social Media"
    style={{
      width: "180px",
      height: "180px",
      objectFit: "contain",
      borderRadius: "8px",
    }}
  />
</div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-6">
                <Modal
                  isOpen={ModalIsOpen}
                  onRequestClose={() => setModalIsOpen(false)}
                  className="popup-send"
                >
                  <div className="block-popup">
                    
                    <h4 className="gold-shine">
                      The mail has been sent successfully
                      <br />
                      Thank you.
                    </h4>
                  </div>
                  <span onClick={() => setModalIsOpen(false)} className="close-btn"></span>
                </Modal>

                <div id="form-wrapper">
                  <div id="form-inner">
                    <form onSubmit={doSubmit}>
                      <p>
                        <input
                          type="text"
                          placeholder="Your Name*"
                          value={Name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <span className="error">{NameError.errText}</span>
                      </p>

                      <p>
                        <input
                          type="text"
                          placeholder="Your Phone*"
                          value={Phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </p>

                      <p>
                        <input
                          type="text"
                          placeholder="Your Email*"
                          value={Email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <span className="error">{EmailError.errText}</span>
                      </p>

                      

                      <p>
                        <input
                          type="text"
                          placeholder="State / City*"
                          value={StateCity}
                          onChange={(e) => setStateCity(e.target.value)}
                        />
                      </p>

                      <p>
                        <select
                          value={Organization}
                          onChange={(e) => setOrganization(e.target.value)}
                          style={{
                          width: "100%",
                          height: "52px",
                          padding: "0 15px",
                          border: "none",
                          background: "#111",
                          color: "#999",
                          outline: "none",
                          fontSize: "20px",
                        }}
                        >
                          <option value="">Contacting Us for*</option>
                          <option value="A4H - PAC">A4H - (PAC)</option>
                          <option value="A4H - 501(c)(3)">A4H - 501(c)(3)</option>
                          <option value="A4H - 501(c)(3)">A4H - 501(c)(4)</option>
                          <option value="FOG - 501(c)(3)">FOG - 501(c)(3)</option>
                        </select>
                      </p>

                      <p className="textarea">
                        <textarea
                          placeholder="Your Message*"
                          rows="4"
                          value={Text}
                          onChange={(e) => setText(e.target.value)}
                        />
                        <span className="error">{TextError.errText}</span>
                      </p>

                      {/* Checkboxes */}
                      


                      <div className="text-center">
                        <input
                          type="submit"
                          className="contact-btn btn-move t2 send-btn"
                          value="Send Message"
                        />
                      </div>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContactA4H
